// composables/useContextMenu.ts
import { ref } from "vue";
import { useEditor } from "./useEditor";
import { useGlobalBlockCommands } from "./useGlobalBlockCommands";

export const useContextMenu = (props, emit) => {
  const { openEditorSheet } = useEditor(props, emit);
  const properties = ref(null);
  const commands = ref([]);

  // Get the function that merges global commands
  const { injectGlobalCommands } = useGlobalBlockCommands();

  // Initialize context menu based on the component’s exposed features and events
  const initializeContextMenu = (componentInstance) => {
    // Clear commands
    commands.value = [];

    // 1) Try to read the block’s 'properties'
    try {
      properties.value = componentInstance?.properties;
    } catch (error) {
      // ...
    }

    // 2) Try to read the block’s 'commands'
    let localCommands = [];
    try {
      localCommands = componentInstance?.commands || [];
    } catch (error) {
      // ...
    }

    // 3) Now auto-inject global commands (like “Layout”)
    //    You might read layout from props.layout or from the block instance
    //    If your block stores the layout in 'props.layout', pass that in:
    const blockProps = {
      ...componentInstance,
      id: properties.value?.id || "", 
    };
    commands.value = injectGlobalCommands(localCommands, blockProps);
  };

  return {
    properties,
    commands,
    initializeContextMenu,
  };
};
